const List = () => import(/* webpackChunkName: "manutencao-pdvi-bundle" */ './main.vue');

export default [
  {
    name: 'manutencao-atendimento',
    path: 'manutencao-atendimento',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Manutenção Atendimento',
      icon: 'medkit',
      can: 'list',
      on: 'atendimentomanutencao',
      neto: true,
      client: 'copass',
    },
  },
];
